import React from 'react';
import { BoxNotification } from '../../../components/containers/BoxNotification';

export type InviteNotificationViewProps = {
  //
  organizationName: string;
};

export const InviteNotificationView = (props: InviteNotificationViewProps): JSX.Element => {
  return <BoxNotification type={'info'}>You have been invited to join {props.organizationName}</BoxNotification>;
};
